module.exports = __webpack_public_path__ + "img/glassicon.638b3580.svg";